export const wmSQ = {
  'skitouring': 'Skitouring',
  'horse': 'Kalërim',
  'walking': 'Shëtitje',
  'running': 'Vrap',
  'asphalt': 'Asfalt',
  'bitumenduro': 'Bitumenduro',
  'onoff': 'OnOff',
  'real_dirt': 'Terren i vërtetë',
  'bar': 'Bar',
  'cycling': 'Çiklizëm',
  'poi_type': 'Pikat e interesit',
  'where': 'Vendndodhjet',
  'lang': 'Gjuha',
  'langPlaceholder': 'Zgjidh',
  'from': 'Nisja',
  'to': 'Mbërritja',
  'ascent': 'Ngjitje',
  'descent': 'Zbritje',
  'distance': 'Distanca',
  'da te': 'nga ti',
  'ele_from': 'Lartësia e nisjes',
  'ele_max': 'Lartësia maksimale',
  'ele_min': 'Lartësia minimale',
  'ele_to': 'Lartësia e mbërritjes',
  'difficulty': 'Vështirësia',
  'cai_scale': 'Shkalla e vështirësisë CAI',
  'duration_forward': 'Kohëzgjatja e vajtjes',
  'duration_backward': 'Kohëzgjatja e kthimit',
  'Filtri': 'Filtrat',
  'Cerca': 'Kërko',
  'tracce': 'Gjurmët',
  'hiking': 'Ecje në natyrë',
  'Escursionismo': 'Ecje në natyrë',
  'escursionismo': 'Ecje në natyrë',
  'i miei percorsi': 'Krijo itinerar',
  'metri': 'Metra',
  'Vedi su OpenStreetMap': 'Shiko në OpenStreetMap',
  'Descrizione Audio': 'Përshkrim Audio',
  'il tuo browser non supporta gli elementi audio': 'Shfletuesi juaj nuk mbështet elementet audio.',
  'stampa': 'Printo',
  'Difficoltà': 'Vështirësia',
  'Scala di difficoltà CAI': 'Shkalla e vështirësisë CAI',
  'Questo percorso non è accessibile': 'Ky itinerar nuk është i aksesueshëm',
  'Descrizione': 'Përshkrimi',
  'Punto di partenza': 'Pika e nisjes',
  'Punto di arrivo': 'Pika e mbërritjes',
  'Dettagli tecnici': 'Detajet teknike',
  'Attività': 'Aktivitetet',
  'Come arrivare': 'Si të arrini',
  'Bici muscolari': 'Biçikleta normale',
  'Bici elettriche': 'Biçikleta elektrike',
  'Mezzi pubblici': 'Transporti publik',
  'Auto Propria': 'Makina personale',
  'Punti di interesse': 'POI',
  'Punto di interesse': 'POI',
  'Collegamenti esterni': 'Lidhje të jashtme',
  'Downloads': 'Shkarkime',
  'edit geohub': 'Modifiko Geohub',
  'NCC': 'NCC',
  'Filtri attivi': 'Filtrat aktivë',
  'Reset filtri': 'Rivendos filtrat',
  'Torna alla home': 'Kthehu në faqen kryesore',
  'Risultati': 'Rezultatet',
  'Caricamento in corso.': 'Po ngarkohet.',
  'Spiacenti non ci sono risultati con questi criteri di ricerca.':
    'Më vjen keq, nuk ka rezultate për këto kritere kërkimi.',
  'duration': 'Kohëzgjatja',
  'Bentornato!': 'Mirë se u ktheve!',
  'Accedi con le tue credenziali per continuare.': 'Hyni me kredencialet tuaja për të vazhduar.',
  'E-mail': 'E-mail',
  "L'e-mail è obbligatoria": 'E-mail-i është i detyrueshëm',
  "Hai inserito un'e-mail non valida": 'Keni futur një e-mail të pavlefshëm',
  'Password': 'Fjalëkalimi',
  'La password è obbligatoria': 'Fjalëkalimi është i detyrueshëm',
  'Accedi': 'Hyr',
  'Hai dimenticato la password?': 'Keni harruar fjalëkalimin?',
  'Accedi e scarica i tuoi percorsi preferiti': 'Hyni dhe shkarkoni itineraret tuaj të preferuar',
  'Puoi anche condividerli con i tuoi compagni di viaggio':
    'Mund t’i ndani edhe me shokët tuaj të udhëtimit',
  'Registrati': 'Regjistrohu',
  'Tracce scaricate': 'Gjurmët e shkarkuara',
  'Utilizzo dati': 'Përdorimi i të dhënave',
  'Registrazioni': 'Regjistrime',
  'Photos': 'Foto',
  'Waypoint': 'Pika ndalese',
  'elimina': 'fshij',
  'Nome': 'Emri',
  'inserisci il tuo nome': 'Shkruani emrin tuaj',
  "E' necessario inserire un nome": 'Duhet të shkruani një emër',
  'inserisci il tuo cognome': 'Shkruani mbiemrin tuaj',
  "E' necessario inserire un cognome": 'Duhet të shkruani një mbiemër',
  'Email': 'Email',
  "E' necessario inserire una email": 'Duhet të shkruani një email',
  "L'email inserita non è un'email valida": 'Email-i i futur nuk është i vlefshëm',
  'Codice Fiscale': 'Kodi Fiskal',
  'Perché ti chiediamo il CF?': 'Pse ju kërkojmë Kodin Fiskal?',
  'Il codice fiscale inserito non è valido': 'Kodi Fiskal i futur nuk është i vlefshëm',
  'inserisci password': 'Shkruani fjalëkalimin',
  "E' necessario inserire la password": 'Duhet të shkruani fjalëkalimin',
  'Conferma password': 'Konfirmo fjalëkalimin',
  'Ripeti password': 'Përsërit fjalëkalimin',
  "E' necessario confermare la password": 'Duhet të konfirmoni fjalëkalimin',
  'La conferma non corrisponde con la password inserita sopra':
    'Konfirmimi nuk përputhet me fjalëkalimin e futur më sipër',
  'Cliccando su "Registrati" accetti la nostra': 'Duke klikuar "Regjistrohu", pranoni tonën',
  'e i': 'dhe',
  'Termini e condizioni': 'Kushtet dhe termat',
  "Errore durante la registrazione dell'utente": 'Gabim gjatë regjistrimit të përdoruesit',
  'Registrazione in corso': 'Regjistrimi është në proces',
  'Perchè ti chiediamo il Codice Fiscale?': 'Pse ju kërkojmë Kodin Fiskal?',
  'Se sei Socia/o CAI inserisci il tuo CF al momento della registrazione. Per te il download delle tappe del Sentiero Italia CAI sarà automaticamente gratuito!':
    'Nëse jeni anëtar/e i CAI, shkruani Kodin Fiskal gjatë regjistrimit. Për ju, shkarkimi i etapave të Sentiero Italia CAI do të jetë automatikisht falas!',
  "Origine dell'immagine": 'Origjina e imazhit',
  'Annulla': 'Anulo',
  'Dalla libreria': 'Nga biblioteka',
  'Scatta una foto': 'Bëj një foto',
  'placeholder': 'Kërko',
  'Carica File': 'Ngarko skedarin',
  'Trascina qui il tuo file o clicca per selezionare':
    'Tërhiqni skedarin këtu ose klikoni për të zgjedhur',
  'Accetta i seguenti formati': 'Pranon formatet e mëposhtme',
  'Tipo di file non supportato': 'Lloji i skedarit nuk mbështetet',
  'Il file non contiene una geometria valida': 'Skedari nuk përmban një gjeometri të vlefshme',
  'Errore durante la lettura del file, riprova': 'Gabim gjatë leximit të skedarit, provo përsëri',
  'Si è verificato un errore durante il salvataggio della traccia. Riprova':
    'Ndodhi një gabim gjatë ruajtjes së gjurmës. Provo përsëri',
  'La traccia è stata salvata correttamente': 'Gjurmët u ruajtën me sukses',
  'Scarica il tracciato GPX': 'Shkarko gjurmën GPX',
  'Scarica il tracciato KML': 'Shkarko gjurmën KML',
  'Scarica il tracciato GEOJSON': 'Shkarko gjurmën GEOJSON',
  'Link utili': 'Lidhje të dobishme',
  'apri pdf': 'Hap PDF',
  'pendenza': 'Pjerrësia',
  'Galleria': 'Galeria',
  'resetta la memoria': 'Rivendos memorien',
  'rimani acceso': 'Qëndro i ndezur',
  'forza il dispositivo a non spegnersi': 'Detyro pajisjen të mos fiket',
  'PAGINE': 'FAQE',
  'I tuoi dati': 'Të dhënat e tua',
  'pages.profile.projectlink': 'Projekti',
  'pages.profile.disclaimerlink': 'Mohim përgjegjësie',
  'pages.profile.creditslink': 'Kreditë',
  'pages.profile.privacylink': 'Privatësia',
  'pages.profile.title': 'Profili',
  'MEMORIA': 'MEMORIA',
  'la distanza espressa in metri che indica la cadenza di rilevamento posizione, più il distance filter è minore piu il consumo della batteria sarà maggiore.':
    'Distanca e shprehur në metra që tregon frekuencën e zbulimit të pozicionit, sa më i vogël të jetë filtri i distancës, aq më i madh do të jetë konsumi i baterisë.',
  "Per registrare tracce e poi correttamente, abilita l'autorizzazione alla posizione nelle impostazioni":
    'Për të regjistruar gjurmët dhe pikat e interesit saktësisht, aktivizo lejen e vendndodhjes në cilësimet.',
  'I miei percorsi': 'Itineraret e mia',
  'Sentieri': 'Shtigjet',
  'Sentiero': 'Shtegu',
  'layers': 'Layers',
  '<span class="green">Livello 1: tratti non interessati dall\'alta quota (quota minore di {{orange}} metri)</span>':
    '<span class="green">Niveli 1: seksione që nuk preken nga lartësia e madhe (lartësia më e ulët se {{orange}} metra)</span>',
  '<span class="orange">Livello 2: tratti parzialmente in alta quota (quota compresa tra {{orange}} metri e {{red}} metri)</span>':
    '<span class="orange">Niveli 2: seksione që nuk preken nga lartësia e madhe (lartësia midis {{orange}} metra dhe {{red}} metra)</span>',
  '<span class="red">Livello 3: in alta quota (quota superiore {{red}} metri)</span>':
    '<span class="red">Niveli 3: seksione që preken nga lartësia e madhe (lartësia më e madhe se {{red}} metra)</span>',
  'Un utente è già stato registrato con questa email.':
    'Një përdorues është tashmë regjistruar me këtë email.',
  "L'email inserita non è corretta. Per favore, riprova.":
    'Email-i që keni futur nuk është e saktë. Ju lutem provoni përsëri.',
  'La password inserita non è corretta. Per favore, riprova.':
    'Fjalëkalimi që keni futur nuk është i saktë. Ju lutem provoni përsëri.',
  'Errore': 'Gabim',
  'Tempo': 'Koha',
  'Velocità media': 'Shpejtësia mesatare',
  'Velocità massima': 'Shpejtësia maksimale',
  'Tipologia di form': 'Lloji i formularit',
  'Seleziona il tipo di form': 'Zgjidh llojin e formularit',
  'File selezionato': 'Skedari i zgjedhur',
  'Carica': 'Ngarko',
  'Aggiornamento effettuato con successo': 'Përditësimi u krye me sukses',
  'Ops!': 'Ops!',
  'Non è stato possibile aggiornare, riprova più tardi':
    'Nuk ishte e mundur të përditësohej, provoni përsëri më vonë',
  'Eliminazione effettuata con successo': 'Fshirja u krye me sukses',
  'Sicuro di voler eliminare questo POI? La rimozione è irreversibile.':
    'Are you sure you want to delete this POI? The removal is irreversible.',
  'Sicuro di voler eliminare questa traccia? La rimozione è irreversibile.':
    'A jeni të sigurt që dëshironi të fshini këtë gjurmë? Fshirja është e pakthyeshme.',
  'Login effettuato con successo': 'Hyrja u krye me sukses',
  'Logout effettuato con successo': 'Shkëputja u krye me sukses',
  'Ottieni indicazioni': 'Merr hulumtime',
  'Mostra altro': 'Shfaq më shumë',
  'Distanza da te': 'Distanca nga ju',
  'Mostra meno': 'Shfaq më pak',
  'Mostra tutti': 'Shfaq të gjitha',
  'Lunghezza': 'Gjatësia',
  'Orario previsto': 'Koha e pritura',
  'Dimensione': 'Madhësia',
  'questo campo è obbligatorio': 'ky fushë është e detyrueshme',
  'Quota': 'Lartësia',
  'I miei downloads': 'Shkarkimet e mia',
  'foto dalla galleria': 'foto nga galeria',
  'Dimensione massime: 3 photo': 'Madhësia maksimale: 3 foto',
  'Aggiungi': 'Shto',
  'Foto': 'Foto',
  '(max 3 photo)': '(maks 3 foto)',
  'art-and-culture': 'Artë dhe kulturë',
  'tourism': 'Turizëm',
  'e-bike': 'Biçikletë elektrike',
  'touring-bike': 'Biçikletë turistike',
  'train-trekking': 'Trekking me tren',
  'road-bike': 'Biçikletë rrugore',
  'ciaspole': 'Shkopinj dëbore',
  'adventure': 'Aventurë',
  'swimming-snorkeling': 'Not dhe snorkeling',
  'birdwatching': 'Vëzhgimi i zogjve',
  'oeno-gastronomy': 'Eno-gastronomia',
  'nordic-walking': 'Ecje nordike',
  'joelette': 'Joëlette',
  'mtb': 'MTB',
  'mountain-bike': 'Biçikletë malore',
  'Ottieni le indicazioni su Google Maps': 'Merr hulumtime në Google Maps',
  'Per il punto di partenza': 'Për pikën e nisjes',
  "Per il punto più vicino in linea d'aria": 'Për pikën më të afërt në vijë të shikimit',
  'Tipo di form': 'Lloji i formularit',
  'massimo': 'maksimum',
  'foto': 'foto',
  'Carica foto dalla libreria': 'Ngarko foto nga biblioteka',
  'Luogo': 'Vendndodhja',
  'Luoghi': 'Vendndodhjet',
  'Percorso': 'Rruga',
  'Percorsi': 'Rrugët',
  'salva': 'ruaj',
  'Il salvataggio è stato completato': 'Ruajtja u krye me sukses',
  'Stai modificando le coordinate del POI, vuoi continuare?':
    'Po e ndryshoni koordinatat e POI-s, dëshironi të vazhdohet?',
  'No': 'No',
  'Sì': 'Po',
  'Attenzione': 'Vëmendje',
  'Disegna': 'Dhëni',
  'Esci': 'Dil',
  'Hai salvato correttamente il tuo waypoint. Puoi visualizzarlo accedendo al tuo profilo.':
    'Keni ruajtur me sukses pikën tuaj të ndalimit. Mund ta shihni duke hyrë në profilin tuaj.',
  'Cliccando su "Registrati" accetti la nostra privacy e i termini e condizioni':
    'Duke klikuar "Regjistrohu", pranoni tonën',
  'culture-history': 'Kultura dhe historia',
  'environmental-education': 'Edukimi ambientale',
  'eating-sleeping': 'Mëngjes dhe mëngjes',
  'by-car': 'Me makinë',
  'Eliminazione': 'Fshirje',
  'Elimina': 'Fshij',
  'Sei sicuro di voler eliminare questi dati?':
    'A jeni të sigurt që dëshironi të fshini këto të dhëna?',
  'Modifica consenso dati': 'Modifiko pëlqimin për të dhënat',
  'Dati non sincronizzati': 'Të dhëna të pa-sinkronizuara',
  'Lingua': 'Gjuha',
  'Azione irreversibile': 'Aksion i pakthyeshëm',
  'Vuoi veramente eliminare il tuo account? È obbligatorio scrivere "delete account" per procedere.':
    'A jeni të sigurt që dëshironi të fshini kontin tuaj? Është e nevojshme të shkruani "delete account" për të vazhduar.',
  'Digita "delete account"': 'Shkruani "delete account"',
  'Conferma': 'Confirm',
  'La conferma non corrisponde. Digita "delete account" per procedere.':
    'Konfirmimi nuk përputhet. Shkruani "delete account" për të vazhduar.',
  'Elimina account': 'Fshij kontin',
  'Aggiornamento disponibile': 'Përditësim i disponueshëm',
  "È disponibile una nuova versione dell'app. Aggiorna per ottenere le ultime funzionalità e miglioramenti.":
    'Një version i ri i aplikacionit është i disponueshëm. Përditëso tani për të marrë veçoritë dhe përmirësimet e fundit.',
  'Aggiorna ora': 'Përditëso tani',
  'Più tardi': 'Më vonë',
  'Versione disponibile': 'Versione disponibile',
  'È stata rilevata una registrazione interrotta. Vuoi riprenderla?':
    'Është një regjistrim i ndalur. Dëshironi të vazhdohet?',
  'Riprendi': 'Vazhdo',
  'Info': 'Info',
  'Chiudi': 'Mbyll',
  'Store non disponibile': 'Store nuk është i disponueshëm',
  "Non è stato possibile aprire direttamente lo store. Prova ad aprire manualmente la pagina dell'app nello store.":
    'Nuk ishte e mundur të hapej drejtpërdrejt store-i. Provoni të hapni manualisht faqen e aplikacionit në store.',
  'Aggiornamento obbligatorio': 'Përditësim i detyrueshëm',
  "Per continuare a utilizzare l'app è necessario installare l'ultima versione disponibile.":
    'Për të vazhduar përdorimin e aplikacionit, duhet të instaloni versionin e fundit të disponueshëm.',
  "È disponibile una nuova versione dell'app.": 'Një version i ri i aplikacionit është i disponueshëm.',
  "Dove": "Vendndodhja",
  "Regione": "Rregioni",
  "Provincia": "Provincë",
  "Comune": "Komuna",
  'layer': 'Layer',
  'Nessun risultato': 'Nuk ka rezultate',
  'Condividi': 'Shpërndaj',
  'Condivisione in corso': 'Duke u shpërndarë',
  'Condivisione non riuscita': 'Shpërndarja dështoi',
  'Riprova': 'Provo përsëri',
  'Aggiungi ai preferiti': 'Shto në të preferuarat',
  'Rimuovi dai preferiti': 'Hiq nga të preferuarat',
  'Preferito': 'Të preferuar',
  'Non preferito': 'Jo i preferuar',
  'Impossibile aggiornare i preferiti, riprova': 'Nuk u arrit të përditësohen të preferuarat, provo përsëri',
  'Modifica profilo': 'Modifiko profilin',
  'Cambia foto': 'Ndrysho foton',
  'Il nome è obbligatorio': 'Emri është i detyrueshëm',
  'Il nome non può superare i 255 caratteri': 'Emri nuk mund të kalojë 255 karaktere',
  'Cognome': 'Mbiemri',
  'Il cognome non può superare i 255 caratteri': 'Mbiemri nuk mund të kalojë 255 karaktere',
  'Salva': 'Ruaj',
};
